
import { defineComponent } from 'vue';
import api from '@/api/api';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import { formsValidations } from '@/utils/formsValidations';
import Grid from '@/components/Grid.vue';
import ModalCrud from '@/components/ModalCrud.vue';

export default defineComponent({
	name: 'SolicitacaoManutencaoView',
	components: {
		Grid,
		ModalCrud
	},
	data() {
		return {
			table: {
				isLoading: false,
				dataset: [],
				gridItemsActions: [
                    {
                        label: 'Aprovar/Reprovar',
                        action: 'decision',
                        icon: 'mdi-checkbox-marked-circle-minus-outline',
                        color: 'warning',
                        display: true,
                        loading: false
                    },
                    {
                        label: 'Finalizar',
                        action: 'finish',
                        icon: 'mdi-check-all',
                        color: 'success',
                        display: true,
                        loading: false
                    },
                    {
                        label: 'Editar',
                        action: 'edit',
                        icon: 'mdi-pencil',
                        color: 'primary',
                        display: true,
                        loading: false
                    }
                ]
            },
			appliedFilters: {
				carros: [],
				servicos: [],
				status: [],
				solicitantes: [],
				dataInicial: null,
				dataFinal: null,
			},
			modals: {
				filtrar: {
					data: {
						form: {
							carros: [],
							servicos: [],
							status: [],
							solicitantes: [],
							dataInicial: null,
							dataFinal: null,
						},
						inputs: {
							carros: [],
							servicos: [],
							status: [],
							solicitantes: [],
						}
					},
					isLoading: false,
					title: 'Filtrar',
					visible: false,
				},
				criarEditar: {
					isLoading: false,
					visible: false,
					title: ''
				},
				decisao: {
					isLoading: false,
					visible: false,
					title: ''
				},
				finalizar: {
					isLoading: false,
					visible: false,
					title: ''
				}
			},
			forms: {
				criarEditar: {
					data: {
						id: 0,
						idCarro: null,
						idTipo: null,
						descricao: '',
						codigoStatus: 'A',
						motivoInativacao: '',
						emAberto: true,
						responsavelDecisao: '',
						observacaoDecisao: '',
						responsavelInativacao: '',
					},
					inputs: {
						carros: [],
						servicos: []
					},
					controls: {
						isValid: true,
					}
				},
				decisao: {
					id: 0,
					servico: '',
					descricao: '',
					aprovado: true,
					observacao: '',
				},
				finalizar: {
					id: 0,
					servico: '',
					obrigaKmAtual: false,
					obrigaProximoServico: false,
					dataExecucao: '',
					kmAtual: null,
					proximaData: null,
					proximaKm: null,
					observacao: '',
				}
			}
		}
	},
	methods: {
		loadDefaultFilter: async function () {
			try {
				const { data } = await api.get('/cars-maintenance-requests/data', {
					params: { typeReq: 'filter' }
				});

				this.modals.filtrar.data.form.status = data.status.filter(x => x.padrao).map(x => x.id);
				this.appliedFilters = { ...this.modals.filtrar.data.form };
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		loadData: async function () {
			try {
				this.table.isLoading = true;

				const { data } = await api.get('/cars-maintenance-requests', {
					params: { ...this.appliedFilters }
				});

				this.table.dataset = data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.table.isLoading = false;
			}
		},
		handleFilter: async function () {
			try {
				this.modals.filtrar.isLoading = true;
				this.modals.filtrar.data.form = { ...this.appliedFilters };
				this.modals.filtrar.visible = true;

				const { data } = await api.get('/cars-maintenance-requests/data', {
					params: { typeReq: 'filter' }
				});

				this.modals.filtrar.data.inputs = data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.filtrar.isLoading = false;
			}
		},
		aplicarFiltro: async function () {
			this.appliedFilters = { ...this.modals.filtrar.data.form };
			this.modals.filtrar.visible = false;

			await this.loadData();
		},
		destroyFilter: function () {
			this.modals.filtrar.visible = false;
			this.modals.filtrar.data.inputs = {
				carros: [],
				servicos: [],
				status: [],
				solicitantes: [],
			};
		},
		handleXlsxExport: async function () {
			try {
				const { XlsxExport } = await import('@/utils/xlsxExport');

				const prepareData = this.table.dataset.map(x => ({
					ID: x.id,
					NUMERO: x.numero,
					PLACA: x.placa,
					REGISTRO: x.dataRegistro,
					SOLICITANTE: x.solicitante,
					SERVICO: x.servico,
					DESCRICAO: x.descricao,
					RESPONSAVEL_DECISAO: x.responsavelDecisao ?? '',
					OBSERVACAO_DECISAO: x.observacaoDecisao ?? '',
					STATUS: x.status,
					MOTIVO_INATIVACAO: x.motivoInativacao ?? '',
				}));

				let instanceExport = new XlsxExport({
					columns: [
						{
							label: "Id",
							name: "ID",
						},
						{
							label: "Num.",
							name: "NUMERO",
						},
						{
							label: "Placa",
							name: "PLACA",
						},
						{
							label: "Registro",
							name: "REGISTRO",
						},
						{
							label: "Solicitado por",
							name: "SOLICITANTE",
						},
						{
							label: "Serviço",
							name: "SERVICO",
						},
						{
							label: "Descrição",
							name: "DESCRICAO",
						},
						{
							label: "Aprovado/Recusado por",
							name: "RESPONSAVEL_DECISAO",
						},
						{
							label: "Observação",
							name: "OBSERVACAO_DECISAO",
						},
						{
							label: "Status",
							name: "STATUS",
						},
						{
							label: "Motivo da Inativação",
							name: "MOTIVO_INATIVACAO",
						},
					],
					data: prepareData,
					title: `Solicitações de Manutenção`
				});

				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao exportar!');
			}
		},
		showModalNewEdit: async function (id) {
			try {
				this.modals.criarEditar.title = id ? 'Editar Solicitação' : 'Nova Solicitação';
				this.modals.criarEditar.visible = true;
				this.modals.criarEditar.isLoading = true;

				let idTipoAtual = null;

				if (id) {
					const { data } = await api.get(`/cars-maintenance-requests/${id}`);

					idTipoAtual = data.idTipo;

					this.forms.criarEditar.data = {
						id: data.id,
						idCarro: data.idCarro,
						idTipo: data.idTipo,
						descricao: data.descricao,
						codigoStatus: data.codigoStatus,
						motivoInativacao: data.motivoInativacao ?? '',
						emAberto: data.emAberto,
						responsavelDecisao: data.responsavelDecisao ?? '',
						observacaoDecisao: data.observacaoDecisao ?? '',
						responsavelInativacao: data.responsavelInativacao ?? '',
					};
				};

				const { data: inputs } = await api.get('/cars-maintenance-requests/data', {
					params: { typeReq: 'form', idTipo: idTipoAtual }
				});

				this.forms.criarEditar.inputs = inputs;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditar.isLoading = false;
			}
		},
		closeModalNewEdit: function () {
			this.modals.criarEditar.visible = false;
			this.forms.criarEditar.data = {
				id: 0,
				idCarro: null,
				idTipo: null,
				descricao: '',
				codigoStatus: 'A',
				motivoInativacao: '',
				emAberto: true,
				responsavelDecisao: '',
				observacaoDecisao: '',
				responsavelInativacao: '',
			};
		},
		saveSolicitacao: async function () {
			try {
				if (this.$refs.form.validate()) {
					this.modals.criarEditar.isLoading = true;

					const [metodo, mensagem] = this.forms.criarEditar.data.id ? ['put', 'alterada'] : ['post', 'criada'];
					await api[metodo]('/cars-maintenance-requests', this.forms.criarEditar.data);

					this.$toast.success(`Solicitação ${mensagem} com sucesso!`);
					this.closeModalNewEdit();
					await this.loadData();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.criarEditar.isLoading = false;
			}
		},
		showModalDecision: async function (item) {
			try {
				const { data } = await api.get(`/cars-maintenance-requests/${item.id}`);

				if (!data.emAberto) {
					this.$toast.warning('Solicitação não está em aberto!');
					return;
				};

				this.forms.decisao = {
					id: data.id,
					servico: data.servico,
					descricao: data.descricao,
					aprovado: true,
					observacao: '',
				};

				this.modals.decisao.title = `Aprovar/Reprovar Solicitação #${data.id}`;
				this.modals.decisao.visible = true;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		saveDecisao: async function () {
			try {
				this.modals.decisao.isLoading = true;

				await api.patch(`/cars-maintenance-requests/${this.forms.decisao.id}/decision`, {
					aprovado: this.forms.decisao.aprovado,
					observacao: this.forms.decisao.observacao
				});

				this.$toast.success(`Solicitação ${this.forms.decisao.aprovado ? 'aprovada' : 'reprovada'} com sucesso!`);
				this.modals.decisao.visible = false;
				await this.loadData();
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.decisao.isLoading = false;
			}
		},
		showModalFinalizar: async function (item) {
			try {
				const { data } = await api.get(`/cars-maintenance-requests/${item.id}`);

				if (!data.aguardandoManutencao) {
					this.$toast.warning('Solicitação não está aguardando manutenção!');
					return;
				};

				this.forms.finalizar = {
					id: data.id,
					servico: data.servico,
					obrigaKmAtual: Boolean(data.obrigaKmAtual),
					obrigaProximoServico: Boolean(data.obrigaProximoServico),
					dataExecucao: '',
					kmAtual: null,
					proximaData: null,
					proximaKm: null,
					observacao: '',
				};

				this.modals.finalizar.title = `Finalizar Solicitação #${data.id}`;
				this.modals.finalizar.visible = true;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		saveFinalizar: async function () {
			try {
				if (this.$refs.formFinalizar.validate()) {
					this.modals.finalizar.isLoading = true;

                    const { dataExecucao, kmAtual, proximaKm, proximaData, observacao } = this.forms.finalizar;

					await api.post(`/cars-maintenance-requests/${this.forms.finalizar.id}/finish`, {
						dataExecucao,
						kmAtual,
						proximaKm,
						proximaData,
						observacao
					});

					this.$toast.success('Solicitação finalizada! Lançamento criado no histórico do carro.');
					this.modals.finalizar.visible = false;
					await this.loadData();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.finalizar.isLoading = false;
			}
		},
		handleGridItemsActions: function (action: 'decision' | 'finish' | 'edit', item) {
			switch (action) {
				case 'decision':
					if (!this.isSupervisorOrAdm) {
						this.$toast.warning('Usuário sem permissão para essa ação!');
						break;
					};

					this.showModalDecision(item);
					break;
				case 'finish':
					if (!this.isSupervisorOrAdm) {
						this.$toast.warning('Usuário sem permissão para essa ação!');
						break;
					};

					this.showModalFinalizar(item);
					break;
				case 'edit':
					this.showModalNewEdit(item.id);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
	},
	computed: {
		isSupervisorOrAdm() {
			const user = this.$store.state.infoUser.current;

			return Boolean(user?.supervisor) || user?.departamento === 4;
		},
		isReadonly() {
			return Boolean(this.forms.criarEditar.data.id) && !this.forms.criarEditar.data.emAberto;
		},
		mostrarInativacao() {
			const { id, emAberto, codigoStatus } = this.forms.criarEditar.data;

			return Boolean(id) && (emAberto || codigoStatus === 'I');
		},
	},
	async mounted() {
		store.commit(M_MENU, "Solicitação de Manutenção");
		await this.loadDefaultFilter();
		await this.loadData();
	},
	setup() {
		return {
			columns,
			formsValidations
		}
	}
})
